export default __webpack_public_path__ + "static/media/1.97714756.jpg";